import { render, staticRenderFns } from "./UsersInscription.vue?vue&type=template&id=c59cc0f8"
import script from "./UsersInscription.vue?vue&type=script&lang=js"
export * from "./UsersInscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports